<section class="relative md:py-24 py-16">
  <div class="container">
      <div class="grid md:grid-cols-12 grid-cols-1 gap-[30px]">
          <div class="lg:col-span-4 md:col-span-6">
              <div class="shadow dark:shadow-gray-700 rounded-md bg-white dark:bg-slate-900 sticky top-20">
                  <div class="p-6">
                      <h5 class="text-lg font-semibold">Vacature</h5>
                  </div>
                  <div class="p-6 border-t border-slate-100 dark:border-t-gray-700">
                      <ul class="list-none">
                          <li class="flex items-center">
                              <i data-feather="user-check" class="h-5 w-5"></i>

                              <div class="ltr:ml-4 rtl:mr-4">
                                  <p class="font-medium">Rol:</p>
                                  <span class="text-earth-dark font-medium text-sm">{{vacature?.titel}}</span>
                              </div>
                          </li>

                          <li class="flex items-center mt-3">
                              <i data-feather="map-pin" class="h-5 w-5"></i>

                              <div class="ltr:ml-4 rtl:mr-4">
                                  <p class="font-medium">Locatie:</p>
                                  <span class="text-earth-dark font-medium text-sm" ><span *ngFor="let v of vacature?.vestigingen;let i=index; first as isFirst"><span *ngIf="!isFirst">,</span> {{ v.naam }}</span></span>
                              </div>
                          </li>

                          <li class="flex items-center mt-3">
                              <i data-feather="clock" class="h-5 w-5"></i>

                              <div class="ltr:ml-4 rtl:mr-4">
                                  <p class="font-medium">Start:</p>
                                  <span class="text-earth-dark font-medium text-sm">{{vacature?.start}}</span>
                              </div>
                          </li>

                          <img class='w-full h-auto mt-8' src='assets/images/logo_square_gold.png' />
                      </ul>
                  </div>
              </div>
          </div><!--end col-->

          <div class="lg:col-span-8 md:col-span-6">
              <p class="text-slate-400 mt-4" [innerHTML]="vacature?.intro | mdtohtml"></p>

              <h5 class="text-lg font-semibold mt-6">Opdracht: </h5>
              <p class="text-slate-400 mt-4" [innerHTML]="vacature?.opdracht | mdtohtml"></p>

              <h5 class="text-lg font-semibold mt-6">Profiel: </h5>
              <p class="text-slate-400 mt-4" [innerHTML]="vacature?.profiel | mdtohtml"></p>

              <h5 class="text-lg font-semibold mt-6">Wij bieden: </h5>
              <p class="text-slate-400 mt-4 pb-6" [innerHTML]="vacature?.aanbod | mdtohtml"></p>

              <hr class="mt-2" />

              <h5 class="text-lg font-semibold mt-6">Interesse? </h5>
              <p class="text-slate-400" [innerHTML]="vacature?.afsluiter | mdtohtml"></p>
          </div><!--end col-->
      </div><!--end grid-->
  </div><!--end container-->

  <!--<div class="container lg:mt-24 mt-16">
      <div class="grid grid-cols-1 pb-8 text-center">
          <h3 class="mb-4 md:text-[26px] md:leading-normal text-2xl leading-normal font-semibold"></h3>

          <p class="text-slate-400 dark:text-slate-300 max-w-xl mx-auto">Search all the open positions on the web. Get your own personalized salary estimate. Read reviews on over 30000+ companies worldwide.</p>
      </div>

      <div class="grid lg:grid-cols-3 md:grid-cols-2 mt-8 gap-[30px]">
          <div class="group shadow dark:shadow-gray-700 p-6 rounded-md bg-white dark:bg-slate-900">
              <div class="flex items-center justify-between">
                  <div class="flex items-center">
                      <div class="w-14 h-14 flex items-center justify-center bg-white dark:bg-slate-900 shadow dark:shadow-gray-700 rounded-md">
                          <img src="assets/images/company/facebook-logo.png" class="h-8 w-8"  alt="">
                      </div>

                      <div class="ltr:ml-3 rtl:mr-3">
                          <a href="employer-detail.html" class="block text-[16px] font-semibold hover:text-emerald-600 transition-all duration-500">Facebook</a>
                          <span class="block text-sm text-slate-400">2 days ago</span>
                      </div>
                  </div>

                  <span class="bg-emerald-600/10 group-hover:bg-emerald-600 inline-block text-emerald-600 group-hover:text-white text-xs px-2.5 py-0.5 font-semibold rounded-full transition-all duration-500">Full Time</span>
              </div>

              <div class="mt-6">
                  <a href="job-detail-one.html" class="text-lg hover:text-emerald-600 font-semibold transition-all duration-500">Web Designer / Developer</a>
                  <h6 class="text-base font-medium"><i class="uil uil-map-marker"></i> Australia</h6>
              </div>

              <div class="mt-6">
                  <div class="w-full bg-gray-100 dark:bg-gray-800 rounded-full h-[6px]">
                      <div class="bg-emerald-600 h-[6px] rounded-full" style="width: 55%"></div>
                  </div>
                  <div class="mt-2">
                      <span class="text-slate-400 text-sm"><span class="text-slate-900 dark:text-white font-semibold inline-block">21 applied</span> of 40 vacancy</span>
                  </div>
              </div>
          </div>

          <div class="group shadow dark:shadow-gray-700 p-6 rounded-md bg-white dark:bg-slate-900">
              <div class="flex items-center justify-between">
                  <div class="flex items-center">
                      <div class="w-14 h-14 flex items-center justify-center bg-white dark:bg-slate-900 shadow dark:shadow-gray-700 rounded-md">
                          <img src="assets/images/company/google-logo.png" class="h-8 w-8"  alt="">
                      </div>

                      <div class="ltr:ml-3 rtl:mr-3">
                          <a href="employer-detail.html" class="block text-[16px] font-semibold hover:text-emerald-600 transition-all duration-500">Google</a>
                          <span class="block text-sm text-slate-400">2 days ago</span>
                      </div>
                  </div>

                  <span class="bg-emerald-600/10 group-hover:bg-emerald-600 inline-block text-emerald-600 group-hover:text-white text-xs px-2.5 py-0.5 font-semibold rounded-full transition-all duration-500">Part Time</span>
              </div>

              <div class="mt-6">
                  <a href="job-detail-one.html" class="text-lg hover:text-emerald-600 font-semibold transition-all duration-500">Marketing Director</a>
                  <h6 class="text-base font-medium"><i class="uil uil-map-marker"></i> USA</h6>
              </div>

              <div class="mt-6">
                  <div class="w-full bg-gray-100 dark:bg-gray-800 rounded-full h-[6px]">
                      <div class="bg-emerald-600 h-[6px] rounded-full" style="width: 55%"></div>
                  </div>
                  <div class="mt-2">
                      <span class="text-slate-400 text-sm"><span class="text-slate-900 dark:text-white font-semibold inline-block">21 applied</span> of 40 vacancy</span>
                  </div>
              </div>
          </div>

          <div class="group shadow dark:shadow-gray-700 p-6 rounded-md bg-white dark:bg-slate-900">
              <div class="flex items-center justify-between">
                  <div class="flex items-center">
                      <div class="w-14 h-14 flex items-center justify-center bg-white dark:bg-slate-900 shadow dark:shadow-gray-700 rounded-md">
                          <img src="assets/images/company/android.png" class="h-8 w-8"  alt="">
                      </div>

                      <div class="ltr:ml-3 rtl:mr-3">
                          <a href="employer-detail.html" class="block text-[16px] font-semibold hover:text-emerald-600 transition-all duration-500">Android</a>
                          <span class="block text-sm text-slate-400">2 days ago</span>
                      </div>
                  </div>

                  <span class="bg-emerald-600/10 group-hover:bg-emerald-600 inline-block text-emerald-600 group-hover:text-white text-xs px-2.5 py-0.5 font-semibold rounded-full transition-all duration-500">Remote</span>
              </div>

              <div class="mt-6">
                  <a href="job-detail-one.html" class="text-lg hover:text-emerald-600 font-semibold transition-all duration-500">Application Developer</a>
                  <h6 class="text-base font-medium"><i class="uil uil-map-marker"></i> China</h6>
              </div>

              <div class="mt-6">
                  <div class="w-full bg-gray-100 dark:bg-gray-800 rounded-full h-[6px]">
                      <div class="bg-emerald-600 h-[6px] rounded-full" style="width: 55%"></div>
                  </div>
                  <div class="mt-2">
                      <span class="text-slate-400 text-sm"><span class="text-slate-900 dark:text-white font-semibold inline-block">21 applied</span> of 40 vacancy</span>
                  </div>
              </div>
          </div>
      </div>
  </div>-->

  <!--
  <div class="container-fluid md:mt-24 mt-16">
      <div class="container">
          <div class="grid grid-cols-1">
              <div class="relative overflow-hidden lg:px-8 px-6 py-10 rounded-xl shadow-lg dark:shadow-gray-700">
                  <div class="grid md:grid-cols-12 grid-cols-1 items-center gap-[30px]">
                      <div class="lg:col-span-8 md:col-span-7">
                          <div class="ltr:md:text-left rtl:md:text-right text-center relative z-1">
                              <h3 class="text-2xl font-semibold text-black dark:text-white mb-4">Explore a job now!</h3>
                              <p class="text-slate-400 max-w-xl">Search all the open positions on the web. Get your own personalized salary estimate. Read reviews on over 30000+ companies worldwide.</p>
                          </div>
                      </div>

                      <div class="lg:col-span-4 md:col-span-5">
                          <div class="ltr:text-right rtl:text-left relative z-1">
                              <a href="employer-detail.html" class="btn bg-emerald-600 hover:bg-emerald-700 border-emerald-600 dark:border-emerald-600 text-white rounded-md">Apply Now</a>
                              <a href="aboutus.html" class="btn bg-emerald-600/5 hover:bg-emerald-600 border-emerald-600/10 hover:border-emerald-600 text-emerald-600 hover:text-white rounded-md ltr:ml-2 rtl:mr-2">Learn More</a>
                          </div>
                      </div>
                  </div>

                  <div class="absolute -top-5 ltr:-left-5 rtl:-right-5">
                      <div class="uil uil-envelope lg:text-[150px] text-7xl text-black/5 dark:text-white/5 ltr:-rotate-45 rtl:rotate-45"></div>
                  </div>

                  <div class="absolute -bottom-5 ltr:-right-5 rtl:-left-5">
                      <div class="uil uil-pen lg:text-[150px] text-7xl text-black/5 dark:text-white/5 rtl:-rotate-90"></div>
                  </div>
              </div>
          </div>
      </div>
  </div>-->
</section>
